import { Button, DialogClose, InterceptDialog } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import simulationImage from "@/assets/fr/simulation.png";
import { PortalContainerContext, UserContext } from "@/contexts";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";
import useSegmentEvent from "@/hooks/useSegmentEvent";

interface UpsellModalProps {
  children: React.ReactNode;
}

const UpsellModal = ({ children }: UpsellModalProps) => {
  const { user } = use(UserContext);
  const { container } = use(PortalContainerContext);
  const { t } = useTranslation("simulation");
  const { sendSegmentEvent } = useSegmentEvent();
  const outboundQueryParams = useOutboundQueryParams();

  const isStartSubscriptionType = user?.company.subscriptionType === "start";
  const bookDemoUrl = `https://www.hellocarbo.com/reservez-votre-demo${outboundQueryParams}`;
  const optionsUrl = "/options/subscription?option=simulation";

  return (
    <InterceptDialog
      show={!user?.policies?.simulation.queries["create"]}
      title={t("modal.title")}
      description={
        isStartSubscriptionType
          ? t("modal.startContent")
          : t("modal.optionContent")
      }
      warningMessage={
        isStartSubscriptionType
          ? t("modal.startWarning")
          : t("modal.optionWarning")
      }
      portalContainer={container as Element}
      content={
        !isStartSubscriptionType && (
          <img src={simulationImage} alt={t("simulation:modal.imageAltText")} />
        )
      }
      footer={
        <>
          {isStartSubscriptionType && (
            <DialogClose asChild>
              <Button
                as={Link}
                to="/pricing"
                shape="link"
                onClick={() =>
                  sendSegmentEvent("Discover the plans", {
                    size: `${user?.company.employees}`,
                  })
                }
              >
                {t("modal.secondaryCta")}
              </Button>
            </DialogClose>
          )}
          <DialogClose asChild>
            <Button
              as="a"
              href={isStartSubscriptionType ? bookDemoUrl : optionsUrl}
              shouldOpenNewTab={isStartSubscriptionType}
              shape="solid"
              onClick={() =>
                sendSegmentEvent(
                  isStartSubscriptionType
                    ? "Subscription Asked"
                    : "option_subscription",
                  {
                    size: `${user?.company.employees}`,
                  }
                )
              }
            >
              {isStartSubscriptionType
                ? t("modal.primaryCta")
                : t("modal.paidAccountCta")}
            </Button>
          </DialogClose>
        </>
      }
    >
      {children}
    </InterceptDialog>
  );
};

export default UpsellModal;
